import React from 'react';
import { Layout } from '../components/common';

const OutwardManagementDemo = () => {
  return (
    <Layout activeNav="outward" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Outward Management</h1>
        <p className="text-gray-600">Manage outbound inventory and shipments.</p>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-gray-600 text-lg">Outward Management Content Coming Soon</p>
      </div>
    </Layout>
  );
};

export default OutwardManagementDemo;
